/**
 * @file
 */
import {Url} from '@/utils/api.js';
import {get, post} from '@/utils/decorate/request';
import toast from '@/utils/decorate/toast';

export default {
    getReplyContent({commit, state}, {query, loadMore = false}) {
        let url = Url.replyListUrl;
        if (loadMore && state.replyData.pageInfo1) {
            let pageNo = state.replyData.pageInfo1.pageNo || 1;
            query.pageNo = +pageNo + 1;
        }
        return get(url, query)
            .then(data => {
                if (Object.prototype.toString.call(data) === '[object Object]') {
                    if (loadMore) {
                        commit('moreReplyData', data);
                    }
                    else {
                        commit('initReplyData', data);
                    }
                }
            })
            .catch(errmsg => toast.error(errmsg));
    },
    getReplyContentTwo({commit, state}, query) {
        let url = Url.replyListUrlTwo;
        return get(url, query);
    },

    /**
     * 回帖请求
     *
     * @param {Object} params 请求的参数集
     * @param {number} params.topicId 帖子id
     * @param {string} params.content 回复内容
     * @param {number=} params.replayId 楼层回复的id，可选
     * @param {string=} params.zid 风控参数zid，可选
     * @return {Promise<Object>} 回帖请求返回参数
     */
    requestAddReplay({state}, {params, cookie = {}}) {
        let url = Url.addReplyUrl;
        return post(url, params, {}, cookie)
            .then(data => {
                toast.success('回帖成功');
            })
            .catch(errmsg => {      
                return Promise.reject(errmsg);
            });
    },

    /**
     * 提交回复
     *
     * @param {Object} params 请求的参数集
     * @param {number} params.topicId 帖子id
     * @param {string} params.content 回复内容
     * @param {number=} params.replayId 楼层回复的id，可选
     * @return {Promise<Object>} 回帖请求返回参数
     */
    submitReplyInfo({state, dispatch, rootState}, params) {
        return dispatch('requestAddReplay', {params});
    }
};
